import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Header = styled.div`
	text-align: center;
	width: 100%;
	padding: 16px 40px;
	border-bottom: 1px solid ${({ theme }) => theme.borders.border200};
`;

export const Body = styled.div``;

export const Info = styled.div`
	color: #c2bdb2;
	font-size: 16px;
	font-weight: 400;
	margin-top: 16px;
	text-align: center;
`;

export const InputWrapper = styled.div<{ errors: boolean }>`
	display: flex;
	justify-content: center;
	margin-top: 24px;

	div {
		display: flex;
		gap: 8px;
		justify-content: center;

		input {
			background-color: #ffffff1a;
			border-radius: 12px;
			border: ${({ errors }) => (errors ? '1px solid #FF3333' : 'none')};
			color: #ffffff;
			text-align: center;
			font-size: 16px;
			font-weight: 400;
			height: 56px;
			width: 48px;
		}
	}
`;

export const NewCodeWrapper = styled.div<{ isTwoFaLoginPending: boolean }>`
	color: ${({ isTwoFaLoginPending }) => (isTwoFaLoginPending ? '#3a3d3c' : '#00D68F')};
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	margin-top: 24px;
	font-size: 16px;
	font-weight: 600;
	cursor: ${({ isTwoFaLoginPending }) => (isTwoFaLoginPending ? 'not-allowed' : 'pointer')};

	svg {
		path {
			fill: ${({ isTwoFaLoginPending }) => (isTwoFaLoginPending ? '#3a3d3c' : '#00D68F')};
		}
	}
`;

export const ButtonWrapper = styled.div`
	padding: 16px;
`;

export const Error = styled.div`
	color: #ff3333;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	margin-top: 6px;
`;
